import { render, staticRenderFns } from "./ViParentSchools.vue?vue&type=template&id=6b94ffac&scoped=true"
import script from "./ViParentSchools.vue?vue&type=script&lang=js"
export * from "./ViParentSchools.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b94ffac",
  null
  
)

export default component.exports